import { render, staticRenderFns } from "./LeftBarStocks.vue?vue&type=template&id=d07b8c10&"
import script from "./LeftBarStocks.vue?vue&type=script&lang=js&"
export * from "./LeftBarStocks.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarStocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports